module.exports = __webpack_public_path__ + "static/media/M-Cure 6.19e703a1.mp4";